// 2025(c) ESIEE Paris
// Author: CANDIA Nicolas <nicolas.candia@esiee.fr>

const color_tablerow = function(tablerow, checkbox) {
    if (checkbox.checked)
        tablerow.classList.add('table-secondary');
    else
        tablerow.classList.remove('table-secondary');
};

const find_tablerow = function(element, max_iter = 5) {
    let i = 0;
    let parent = element.parentElement;
    while (parent && parent.tagName !== "TR" && i < max_iter) {
        parent = parent.parentElement;
        i++;
    }
    return (parent && parent.tagName === "TR") ? parent : null;
};

export const input_select_tablerow = function(selector, options = {}) {

    document.querySelectorAll(selector).forEach(checkbox => {
        const tablerow = find_tablerow(checkbox, ("maxiter" in options) ? options['maxiter'] : 5);
        
        if (tablerow) {
            color_tablerow(tablerow, checkbox);
            checkbox.addEventListener('change', function() {
                color_tablerow(tablerow, checkbox);
            });
        }
    });

};